@import '../ui-cms-contact-channels-footer';

ui-cms-contact-channels-footer-miscellaneous {
  display: block;

  .sr-only {
    @include sr-only;
  }
}
